import React, { useState } from "react";
import {
  Box,
  Typography,
  TextField,
  Button,
  Paper,
  InputAdornment,
  IconButton,
} from "@mui/material";
import { Visibility, VisibilityOff } from "@mui/icons-material";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import api from "../../api/axiosInstance";
import iconImg from "../../assets/image/swc.png";

import "react-toastify/dist/ReactToastify.css";

const Login = () => {
  const navigate = useNavigate();
  const [showPassword, setShowPassword] = useState(false);
  const [formData, setFormData] = useState({ user_name: "", password: "" });

  const handleTogglePassword = () => setShowPassword((prev) => !prev);

  const handleChange = ({ target: { name, value } }) => {
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleLogin = async () => {
    const { user_name, password } = formData;

    if (!user_name.trim() || !password.trim()) {
      toast.warning("กรุณากรอก username และ password", { autoClose: 3000 });
      return;
    }

    try {
      const { data } = await api.post("/api/member/login", {
        user_name,
        password,
      });

      toast.success(data.message || "เข้าสู่ระบบสำเร็จ", { autoClose: 3000 });
      localStorage.setItem("token", data.token);

      if (data.user) {
        localStorage.setItem("user", JSON.stringify(data.user));
      } else {
        localStorage.setItem("user", JSON.stringify(data));
      }

      setTimeout(() => {
        navigate("/home");
      }, 1000);
    } catch (err) {
      const message =
        err.response?.data?.message ||
        err.response?.data?.error ||
        "เกิดข้อผิดพลาดในการเข้าสู่ระบบ";

      toast.error(message);
    }
  };

  return (
    <>
      <Box
        sx={{
          width: "99vw",
          height: "97vh",
          display: "flex",
          backgroundColor: "#80BDB6",
          position: "relative",
          justifyContent: "center",
          alignItems: "center",
          overflow: "hidden"
        }}
      >
        {/* Bottom Left */}
        <Box sx={{ position: "absolute", bottom: 16, left: 16 }}>
          <Typography variant="body2" color="text.secondary" sx={{ color: "rgba(0, 0, 0, 0.6)" }}>
            กองควบคุมมาตรฐานซอฟต์แวร์ ศซว.ทอ.
          </Typography>
        </Box>

        {/* Login Form */}
        <Paper
          elevation={4}
          sx={{
            padding: 4,
            width: { xs: "90%", sm: "65%", md: "45%", lg: "35%" },
            textAlign: "center",
            display: "flex",
            flexDirection: "column",
            // gap: 2.5,
            borderRadius: "20px",
            backgroundColor: "#C8EAE6",
          }}
        >
          <img
            src={iconImg}
            alt="logo"
            style={{
              width: 160,
              height: 160,
              display: "block",
              margin: "0 auto",
            }}
          />

          <Typography variant="h5" fontWeight="bold" color="#1F534D">
            Software Estimation Application
          </Typography>

          {/* Inputs Section */}
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              gap: 2,
              width: "100%"
            }}
          >
            <TextField
              variant="outlined"
              label="Username"
              name="user_name"
              value={formData.user_name}
              onChange={handleChange}
              sx={{
                width: "80%",
                "& .MuiOutlinedInput-root": {
                  borderRadius: "20px",
                  backgroundColor: "#fff",
                },
              }}
            />

            <TextField
              variant="outlined"
              label="Password"
              name="password"
              type={showPassword ? "text" : "password"}
              value={formData.password}
              onChange={handleChange}
              sx={{
                width: "80%",
                "& .MuiOutlinedInput-root": {
                  borderRadius: "20px",
                  backgroundColor: "#fff",
                },
              }}
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton onClick={handleTogglePassword} edge="end">
                      {showPassword ? <VisibilityOff /> : <Visibility />}
                    </IconButton>
                  </InputAdornment>
                ),
              }}
            />
          </Box>

          {/* 🌟 ย้ายส่วนที่ 1: กลุ่มปุ่ม เข้าสู่ระบบ และ ลงทะเบียน ขึ้นมาไว้ด้านบนตามต้องการ */}
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              gap: 1.5,
              width: "80%",
              margin: "0 auto",
              mt: 1
            }}
          >
            <Button
              variant="contained"
              onClick={handleLogin}
              fullWidth
              sx={{
                borderRadius: "20px",
                backgroundColor: "#368D83",
                color: "#fff",
                py: 1.1,
                fontWeight: "600",
                "&:hover": {
                  backgroundColor: "#286961",
                },
              }}
            >
              เข้าสู่ระบบ
            </Button>

            <Button
              variant="outlined"
              onClick={() => navigate("/register")}
              fullWidth
              sx={{
                borderRadius: "20px",
                borderColor: "#368D83",
                color: "#368D83",
                py: 1.1,
                fontWeight: "600",
                backgroundColor: "rgba(255, 255, 255, 0.6)",
                "&:hover": {
                  borderColor: "#286961",
                  color: "#286961",
                  backgroundColor: "rgba(54, 141, 131, 0.08)",
                },
              }}
            >
              ลงทะเบียน
            </Button>
          </Box>

          {/* 🌟 ปรับปรุงใหม่: กลุ่มลิงก์ทางเลือก (OTP และ ลืมรหัสผ่าน) เรียงเซนเตอร์ตรงกลางคู่กัน */}
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              gap: 1, // ระยะห่างระหว่างปุ่ม OTP กับ ลืมรหัสผ่าน
              width: "80%",
              margin: "0 auto",
              mt: 2
            }}
          >
            <Button
              variant="text"
              onClick={() => navigate("/authentication")}
              sx={{
                color: "#368D83",
                fontWeight: "600",
                fontSize: "0.875rem",
                whiteSpace: "nowrap",
                "&:hover": {
                  backgroundColor: "rgba(54, 141, 131, 0.08)"
                }
              }}
            >
              ดำเนินการเข้าสู่ระบบด้วย OTP
            </Button>

            <Button
              variant="text"
              onClick={() =>
                navigate("/forget-password", {
                  state: { user_name: formData.user_name },
                })
              }
              sx={{
                color: "#1F534D",
                fontWeight: "500",
                fontSize: "0.875rem",
                whiteSpace: "nowrap",
                "&:hover": {
                  backgroundColor: "rgba(31, 83, 77, 0.08)"
                }
              }}
            >
              ลืมรหัสผ่าน?
            </Button>
          </Box>
        </Paper>
      </Box>
    </>
  );
};

export default Login;